import { OthersCatalog } from "shared/catalog/OthersCatalog";
import { useI18n } from "utils/with-i18n.utils";

export const OtherDevices = () => {
  const i18n = useI18n();

  return (
    <section className="flex flex-col justify-center items-center mb-16 lg:mb-24">
      <h2 className="my-12 text-3xl font-medium text-center lg:text-6xl">
        {i18n.t("product.otherDevices.title")}
      </h2>

      <div className="flex flex-wrap gap-4 justify-center px-5 w-full max-w-7xl">
        <OthersCatalog />
      </div>
    </section>
  );
};
